import React from 'react'
import Styles from "../../Styles/DashBoard.module.css"
import TopBar from "../../Components/LayoutWapper/Global/TopBar";
import Sidebar from "../../Components/LayoutWapper/Global/SideBar";
import Header from '../../Components/Header';




function index() {
  return  (
      <div className={Styles.container}>
      <div className={Styles.box}>
    </div>
      <TopBar/>
      <div className={Styles.main} >
       <div className={Styles.context} >
        
       <div className={Styles.nav}>
       <Sidebar />
       </div>
       <div className={Styles.center}>
        <div className={Styles.info}>
         <Header/>
          </div>
        
       </div> 
       </div>
      </div>
      </div>
  )
}

export default index